import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";
import DialogActions from "@material-ui/core/DialogActions";

import MessagesList from "../MessagesList";
import { i18n } from "../../translate/i18n";

import { ReplyMessageProvider } from "../../context/ReplyingMessage/ReplyingMessageContext";

const useStyles = makeStyles((theme) => ({
    dialog: {
        minHeight: "80vh",
        maxHeight: "90vh",
    },
    content: {
        padding: 0,
        display: "flex",
        flexDirection: "column",
        height: "100%",
    },
}));

const TicketPeekModal = ({ open, onClose, ticketId }) => {
    const classes = useStyles();

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="md"
            fullWidth
            classes={{ paper: classes.dialog }}
        >
            <DialogTitle id="form-dialog-title">
                Espiar conversa 👀
            </DialogTitle>
            <DialogContent className={classes.content}>
                <ReplyMessageProvider>
                    <MessagesList
                        ticketId={ticketId}
                        isGroup={false}
                        isSpy={true}
                    />
                </ReplyMessageProvider>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary" variant="contained">
                    Fechar
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default TicketPeekModal;
